import AgendaContextProvider from './contexts/AgendaContext';
import { ErrorProvider } from './contexts/ErrorProvider';
import PrestadoresRoutes from './Routes';
import CustomTheme from './utils/CustomTheme';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es-mx';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
      <AgendaContextProvider>
        <CustomTheme>
          <ErrorProvider>
            <PrestadoresRoutes />
          </ErrorProvider>
        </CustomTheme>
      </AgendaContextProvider>
    </LocalizationProvider>
  );
}

export default App;
